// Single source of truth for the frontend build tag. Imported in App.js (gestione header)
// and in HomePortal.jsx (home page footer).
export const BUILD_VERSION = "2.9.996";
export const BUILD_DATE = "2026-06-30";
export const BUILD_TAG = `v${BUILD_VERSION}-${BUILD_DATE}`;
